import React          from 'react';
import numeral        from 'numeral';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PriceMatrixCell from 'pu-react/components/PriceMatrixCell';
import { START } from 'pu-data/QuoteSteps'
import { getClassName } from './PriceMatrixHead';

const show_icon = (restricted_price, row, col) => ((isManager && restricted_price !== undefined) ? restricted_price[row][col] : false);

class CustomPriceMatrixCell extends PriceMatrixCell {
  cellClass() {
    return getClassName(this.props.leadTime)
  }

  renderEmpty() {
    // return '\u00A0';
    return '';
  }

  showUnitPrice() {
    const aditional = show_icon(this.props.restricted_price, this.props.row, this.props.col) ? <FontAwesomeIcon icon={['fas', 'exclamation-circle']} /> : null
    const price = `$${numeral(this.unitPrice()).format('0.00')}`
    return (
      <div className="d-flex justify-content-between aligns-items-center">
        {aditional} {price}
      </div>
    )
  }

  render() {
    const { leadTime } = this.props;
    const total = this.totalPrice();
    let field;
    if (total == null) {
      field = this.renderEmpty();
    } else if (this.props.quoteStep === START) {
      field = this.renderInput();
    }
    // else if (leadTime < 10) {
    //   if (total === 0) {
    //     field = this.renderEmpty();
    //   } else {
    //     field = this.showUnitPrice();
    //   }
    // }
    else if (total > 0) {
      field = this.renderInput();
    } else {
      field = this.renderEmpty();
    }
    return <td className={this.cellClass()}> {field}</td>;
  }
}

export default CustomPriceMatrixCell;
